module.exports = __webpack_public_path__ + "media/success_long.4233eceb.flac";